// Theme por edad del estudiante.
// 5-10 → "kids": muy amigable, caritas grandes, animaciones, gradientes amarillos
// 11-15 → "teen": versátil, mantiene caritas + texto, paleta más vibrante
// 15-20 → "young": moderno y amigable, sin caritas, chips minimalistas, paleta JASQ
// 20+ → "adult": diseño formal (el original Hito 2)
export function getAgeTheme(age) {
  const a = Number(age) || 0;
  if (a > 0 && a <= 10) return THEMES.kids;
  if (a > 10 && a <= 15) return THEMES.teen;
  if (a > 15 && a <= 20) return THEMES.young;
  return THEMES.adult;
}

const COMMON_FACES_AGREE = [
  { v: 1, face: "😞", label: "Totalmente NO",   color: "#EF4444", bg: "#FFE9EC" },
  { v: 2, face: "🙁", label: "No",              color: "#F97316", bg: "#FFE9D6" },
  { v: 3, face: "😐", label: "Más o menos",     color: "#A1A1AA", bg: "#F2F4FA" },
  { v: 4, face: "🙂", label: "Sí",              color: "#16A34A", bg: "#E7F4E9" },
  { v: 5, face: "😄", label: "¡Totalmente SÍ!", color: "#2C49A0", bg: "#E8EEFB" },
];
const COMMON_FACES_FREQ = [
  { v: 1, face: "🌑", label: "Nunca",        color: "#1F2547", bg: "#F2F4FA" },
  { v: 2, face: "🌒", label: "Rara vez",     color: "#6B7280", bg: "#F2F4FA" },
  { v: 3, face: "🌓", label: "A veces",      color: "#F5B82E", bg: "#FFF7DA" },
  { v: 4, face: "🌔", label: "Casi siempre", color: "#16A34A", bg: "#E7F4E9" },
  { v: 5, face: "🌕", label: "¡Siempre!",    color: "#A43790", bg: "#F3E8FF" },
];

// Versiones formales (sin caritas) para adult
const ADULT_AGREE = [
  { v: 1, label: "Totalmente en desacuerdo", color: "#EF4444" },
  { v: 2, label: "En desacuerdo",            color: "#F97316" },
  { v: 3, label: "Neutral",                  color: "#6E7591" },
  { v: 4, label: "De acuerdo",               color: "#16A34A" },
  { v: 5, label: "Totalmente de acuerdo",    color: "#2C49A0" },
];
const ADULT_FREQ = [
  { v: 1, label: "Nunca",         color: "#6E7591" },
  { v: 2, label: "Rara vez",      color: "#6E7591" },
  { v: 3, label: "A veces",       color: "#F5B82E" },
  { v: 4, label: "Frecuentemente",color: "#16A34A" },
  { v: 5, label: "Siempre",       color: "#A43790" },
];

export const THEMES = {
  kids: {
    id: "kids",
    label: "Niños 5–10",
    tone: "¡Hola! Vamos a divertirnos contestando juntos. 🎉",
    headerGradient: "from-[#FFCC28] via-[#FFE16A] to-[#FFF7DA]",
    headerEmoji: "👋",
    headerTitle: "¡Hola amig@! Vamos a divertirnos",
    cardRadius: "rounded-3xl",
    cardBorder: "border-4 border-[#1F2547]",
    cardShadow: "shadow-[6px_6px_0_#1F2547]",
    questionPadding: "p-5",
    questionTextSize: "text-base md:text-lg",
    questionRadius: "rounded-2xl",
    questionBorder: "border-4",
    numberSize: "w-8 h-8 text-sm",
    optsLayout: "faces", // emojis grandes
    facesAgree: COMMON_FACES_AGREE,
    facesFreq: COMMON_FACES_FREQ,
    faceSize: "text-4xl",
    optionBorder: "border-4",
    optionRadius: "rounded-2xl",
    mascotSize: 100,
    nextLabel: "¡Siguiente!",
    submitLabel: "¡Terminar!",
    startLabel: "¡Empezar la aventura!",
    welcomeIntroTitle: "Antes de empezar:",
    welcomeBullets: [
      { e: "🎯", t: "No es un examen, sólo cuéntame cómo te sientes." },
      { e: "📚", t: "Tómate tu tiempo, no hay prisa." },
      { e: "🧠", t: "Yo te acompañaré en cada paso." },
    ],
    scoreLabels1to10: { left: "😞 1", right: "10 🤩" },
    motivationStyle: "bg-[#FFF7DA] border-2 border-[#FFCC28] rounded-2xl px-4 py-2 italic",
    blockProgressStyle: "emoji", // muestra ✅🎯⚪
    primaryBtnGradient: "from-[#FFCC28] to-[#FFA500]",
    submitBtnGradient: "from-[#A43790] to-[#D63384]",
    fontWeight: "font-black",
  },
  teen: {
    id: "teen",
    label: "Adolescentes 11–15",
    tone: "¡Hey! Cuéntanos cómo te sientes, sin filtro.",
    headerGradient: "from-[#A43790] via-[#D63384] to-[#FFCC28]",
    headerEmoji: "🚀",
    headerTitle: "¡Hey! ¿Cómo te sientes con las mates?",
    cardRadius: "rounded-2xl",
    cardBorder: "border-2 border-[#1F2547]",
    cardShadow: "shadow-lg",
    questionPadding: "p-5",
    questionTextSize: "text-base",
    questionRadius: "rounded-xl",
    questionBorder: "border-2",
    numberSize: "w-7 h-7 text-xs",
    optsLayout: "faces",
    facesAgree: COMMON_FACES_AGREE,
    facesFreq: COMMON_FACES_FREQ,
    faceSize: "text-3xl",
    optionBorder: "border-2",
    optionRadius: "rounded-xl",
    mascotSize: 88,
    nextLabel: "Siguiente",
    submitLabel: "Enviar respuestas",
    startLabel: "Empezar",
    welcomeIntroTitle: "Lo que necesitas saber:",
    welcomeBullets: [
      { e: "✨", t: "No es un examen. Tu honestidad nos ayuda a apoyarte mejor." },
      { e: "📊", t: "Verás un avance por bloque." },
      { e: "💬", t: "Te dejaré tips motivadores en el camino." },
    ],
    scoreLabels1to10: { left: "1 ·  poco", right: "10 ·  mucho" },
    motivationStyle: "bg-[#F3E8FF] border-l-4 border-[#A43790] rounded-r-xl px-4 py-2 italic",
    blockProgressStyle: "dots",
    primaryBtnGradient: "from-[#A43790] to-[#D63384]",
    submitBtnGradient: "from-[#2C49A0] to-[#A43790]",
    fontWeight: "font-extrabold",
  },
  young: {
    id: "young",
    label: "Jóvenes 16–20",
    tone: "Responde con honestidad. Nadie verá tus respuestas individuales.",
    headerGradient: "from-[#1F2547] via-[#2C49A0] to-[#315197]",
    headerEmoji: "🎯",
    headerTitle: "Tu valoración emocional CEP",
    cardRadius: "rounded-2xl",
    cardBorder: "border border-[#E1E5F0]",
    cardShadow: "shadow-sm",
    questionPadding: "p-4",
    questionTextSize: "text-sm md:text-base",
    questionRadius: "rounded-xl",
    questionBorder: "border-2",
    numberSize: "w-6 h-6 text-xs",
    optsLayout: "chips", // sin emojis, chips con número + label corto
    facesAgree: COMMON_FACES_AGREE, // referencia, no se usan caritas
    facesFreq: COMMON_FACES_FREQ,
    faceSize: "text-base",
    optionBorder: "border-2",
    optionRadius: "rounded-lg",
    mascotSize: 72,
    nextLabel: "Continuar",
    submitLabel: "Finalizar y enviar",
    startLabel: "Comenzar",
    welcomeIntroTitle: "Antes de comenzar:",
    welcomeBullets: [
      { e: "→", t: "No es un examen. Tu sinceridad mejora tu plan personalizado." },
      { e: "→", t: "Avance por bloque · progreso visible siempre." },
      { e: "→", t: "Tus respuestas son confidenciales (sólo agregadas para tu docente)." },
    ],
    scoreLabels1to10: { left: "1 — bajo", right: "10 — alto" },
    motivationStyle: "bg-[#F7F8FA] border-l-4 border-[#2C49A0] rounded-r-lg px-4 py-2 text-[#4C5478]",
    blockProgressStyle: "bar",
    primaryBtnGradient: "from-[#2C49A0] to-[#1F2547]",
    submitBtnGradient: "from-[#A43790] to-[#1F2547]",
    fontWeight: "font-bold",
  },
  adult: {
    id: "adult",
    label: "Adultos 20+",
    tone: "Cuestionario profesional · responda con honestidad.",
    headerGradient: "from-white via-white to-[#F7F8FA]",
    headerEmoji: null,
    headerTitle: null, // usar título de la plantilla
    cardRadius: "rounded-xl",
    cardBorder: "border border-[#E1E5F0]",
    cardShadow: "shadow-sm",
    questionPadding: "p-4",
    questionTextSize: "text-sm",
    questionRadius: "rounded-lg",
    questionBorder: "border",
    numberSize: "w-6 h-6 text-xs",
    optsLayout: "table",
    adultAgree: ADULT_AGREE,
    adultFreq: ADULT_FREQ,
    optionBorder: "border-2",
    optionRadius: "rounded-md",
    mascotSize: 56,
    nextLabel: "Siguiente bloque",
    submitLabel: "Enviar cuestionario",
    startLabel: "Iniciar",
    welcomeIntroTitle: "Indicaciones:",
    welcomeBullets: [
      { e: "•", t: "No es un examen de conocimientos." },
      { e: "•", t: "Sus respuestas son confidenciales y agregadas." },
      { e: "•", t: "Avance por bloque · puede retroceder en cualquier momento." },
    ],
    scoreLabels1to10: { left: "1", right: "10" },
    motivationStyle: "text-[11px] text-[#6E7591] italic",
    blockProgressStyle: "text",
    primaryBtnGradient: "from-[#1F2547] to-[#1F2547]",
    submitBtnGradient: "from-[#A43790] to-[#A43790]",
    fontWeight: "font-bold",
  },
};
